import RedoUndo from './src/RedoUndo.vue';

RedoUndo.install = function(Vue) {
  Vue.component(RedoUndo.name, RedoUndo);
}

export default RedoUndo;